import React from "react";
import RegistrationBox from "../RegistrationBox";
import { FormFields } from "../../../contexts/RegistrationContext";
import { OrangeRegistrationInput } from "../Inputs";
import { Col, Form, Row } from "antd";

const PrivateDetails = ({ missingFields }) => {
  const inputs = [
    FormFields.PERSONAL_INFO.FIRST_NAME,
    FormFields.PERSONAL_INFO.LAST_NAME,
    FormFields.PERSONAL_INFO.NATIONAL_ID,
    FormFields.PERSONAL_INFO.EMAIL,
    FormFields.PERSONAL_INFO.CELL,
    FormFields.PERSONAL_INFO.COUNTRY,
  ];

  return (
    <RegistrationBox
      title="פרטים אישיים"
      className="agent-reg-stage-card"
      lead="נזהה אתכם ונוכל לפתוח חשבון סוכן מאומת במהירות."
    >
      <Form layout="vertical" className="agent-reg-fields-form">
        <Row gutter={[14, 2]} className="agent-reg-fields-grid">
          {inputs.map((key) => (
            <Col xs={24} sm={12} key={key}>
              <OrangeRegistrationInput registrationKey={key} missingFields={missingFields} />
            </Col>
          ))}
        </Row>
      </Form>
    </RegistrationBox>
  );
};

export default PrivateDetails;
